import clsx from 'clsx'
import styles from './sign-up-actions.module.scss'
import React, { PropsWithChildren } from 'react'

interface Props {
    className?: string
}

export const SignUpActions: React.FC<PropsWithChildren<Props>> = ({ children, className }) =>
    (
        <div className={clsx(styles.actions, className)}>
            {children}
        </div>
    )
